import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import * as helpers from "../helpers";

class projectViews {
  _parentElement = document.querySelector(".projects");
  _currentPage = 1;
  _totalPage;
  _scroller = gsap.registerPlugin(ScrollTrigger);

  //Render layouts
  renderLayout(data) {
    //Init
    this.generateAllLayout(data);
    this._selectAllPageElements();
    //Timeline for stack cards animations
    helpers.generateCardsTimeline(this._pages);
  }

  //Generate all Pages at same time
  generateAllLayout(data) {
    let allPagesHTML = "";

    data.map((project) => {
      allPagesHTML += `

      <div class="projects__layer" data-page="${this._currentPage}">
        <div class="projects__layout">
          <span class="projects__pages">
            <h4 class="projects__pages--current">${helpers.formatPage(this._currentPage)}</h4>
            <h4 class="projects__pages--last"></h4>
          </span>

          <div class="projects__box-menu">
            <h2 class="projects__menu-title">${project.title}</h2>
             <img
              class="projects__logo"
              src="${project.logo}"
              alt="${project.title} logo"
            />
            <nav class="projects__nav">
              <ul class="projects__list">
                <li class="projects__item">
                  <a class="projects__link" href="" id ="pres"><h3>Presentazione</h3></a>
                </li>
                <li class="projects__item">
                  <a class="projects__link" href="" id="stack"
                    ><h3 class="stack__link">Stack</h3></a
                  >
                </li>
                <li class="projects__item">
                  <a class="projects__link" href="${project.previewLink}" id="demo" target="_blank"><h3>Live demo</h3></a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="projects__phone ">
          <a class="projects__link projects__link-phone" id="demo" href="${project.previewLink}"><h3>
          Apri progetto</h3></a>
            <iframe
              class="projects__preview"
              src=${project.previewLink}
              title="Live projects preview"
            ></iframe>
          </div>
          <div class="projects__box-red"></div>
           <div class="projects__box-content">
            <span class="projects__concept projects__concept--stackPage">${project.concept}</span>
            <h2 class="projects__title">${project.title}</h2>
            <p class="projects__p">
              ${project.desc}
            </p>
           </div>

          </div>
        </div>
        <div class="projects__spacer projects__spacer-page1"></div>`;

      this._currentPage++;

      const cards = helpers.generateCards(project);

      allPagesHTML += `<div class="projects__layer" data-page="${this._currentPage}">
        <div class="projects__layout projects__layout-page2">
          <span class="projects__pages">
            <h4 class="projects__pages--current">${helpers.formatPage(this._currentPage)}</h4>
            <h4 class="projects__pages--last"></h4>
          </span>

          <div class="projects__box-menu">
            <h2 class="projects__menu-title">${project.title}</h2>
             <img
              class="projects__logo"
              src="${project.logo}"
              alt="${project.title} logo"
            />
            <nav class="projects__nav">
              <ul class="projects__list">
                <li class="projects__item">
                  <a class="projects__link" href="" id="pres"><h3>Presentazione</h3></a>
                </li>
                <li class="projects__item">
                  <a class="projects__link" href="" id="stack"
                    ><h3 class="stack__link">Stack</h3></a
                  >
                </li>
                <li class="projects__item">
                  <a class="projects__link" href="${project.previewLink}" id="demo" target="_blank"><h3>Live demo</h3></a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="projects__phone projects__phone-stackPage">
            <iframe
              class="projects__preview"
              src=${project.previewLink}
              title="Live projects preview"
            ></iframe>
          </div>
          <div class="projects__box-red"></div>
           <div class="projects__box-content">
            <span class="projects__concept projects__concept--stack">${project.concept}</span>
            <h2 class="projects__title projects__title--stack">Stack</h2>
             <div class="projects__tech">
              ${cards}
            </div>
           </div>

          </div>
        </div>
        <div class="projects__spacer"></div>`;
      this._currentPage++;
    });

    this._parentElement.innerHTML = allPagesHTML;

    this._totalPage = this._currentPage - 1;

    document
      .querySelectorAll(".projects__pages--last")
      .forEach(
        (span) => (span.innerHTML = helpers.formatPage(this._totalPage)),
      );

    //Reset
    this._currentPage = 1;
  }

  //Projects navigation
  addHandlerProjectNav() {
    document.querySelectorAll(".projects__link").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const currentPage = link.closest(".projects__layer").dataset.page;

        if (link.id === "pres") {
          helpers.isEven(currentPage)
            ? this._scrollToPage(Number(currentPage) - 1)
            : "";
        } else if (link.id === "stack") {
          console.log(currentPage);
          helpers.isEven(currentPage)
            ? ""
            : this._scrollToPage(Number(currentPage) + 1);
        } else if (link.id === "demo") {
          window.open(link.href);
        }
      });
    });
  }

  //Change page number
  changePage(page) {
    this._currentPage = page;
    this._pagesSpan.querySelector(".projects__pages--current").innerHTML =
      helpers.formatPage(this._currentPage);
  }

  _scrollToPage(targetPage) {
    let absoluteTop = this._parentElement.offsetTop;

    for (let i = 1; i < targetPage; i++) {
      const pageEl = this._pages[i].element;
      absoluteTop += pageEl.offsetHeight;

      //Add spacer if exist
      if (pageEl.nextElementSibling?.classList.contains("projects__spacer")) {
        absoluteTop += pageEl.nextElementSibling.offsetHeight;
      }
    }

    window.scrollTo(0, absoluteTop);
  }

  //Creating an object with all projects selection
  _selectAllPageElements() {
    this._pages = {};
    //One object for every page
    for (let i = 1; i <= this._totalPage; i++) {
      const pageEl = document.querySelector(`[data-page="${i}"]`);
      this._pages[i] = {
        element: pageEl,
        spacer: pageEl.nextElementSibling,
        layout: pageEl.querySelector(".projects__layout"),
        pagesSpan: pageEl.querySelector(".projects__pages"),
        menu: pageEl.querySelector(".projects__box-menu"),
        iframe: pageEl.querySelector(".projects__preview"),
        phone: pageEl.querySelector(".projects__phone"),
        red: pageEl.querySelector(".projects__box-red"),
        content: pageEl.querySelector(".projects__box-content"),
        tech: pageEl.querySelector(".projects__tech"), // null for type A pages
      };
    }
  }
}

export default new projectViews();
